<template>
    <v-card tile flat style="height:100%;" >
        <v-card-text>
            <div style="text-align:left; margin:0.5rem;margin-bottom:1.5rem">
                <div class="headline">Personal access api-keys</div>
                <div class="body-1">Api-keys are secret tokens need to authenticate HTTP requests for data uplink.</div>
            </div>

            <v-layout row wrap>
                <!-- <v-flex xs12 sm12 md12 > -->
                <v-flex xs12 sm12 md12 >
                    <itemlist 
                        :headers="[
                            {text:'Api-key name',value:'label'},
                            {text:'Create timestamp',value:'createTime'},
                        ]" 
                        :values="apiKeys" 
                        v-on:selected="apiKey=$event;"
                        v-on:unselected="apiKey=null;"
                    ></itemlist>
                </v-flex>
                <v-flex xs12 sm12 md12 v-if="apiKey" >
                    <v-card class="elevation-0" >
                        <v-card-title class="title" style="padding-top:1rem">
                            <span>Details of <v-chip>{{ apiKey.label }}</v-chip> api-key</span>
                        </v-card-title>
                        <v-card-text style="padding-top:0;padding-bottom:0">
                        <v-layout row wrap style="text-align: left;margin-left:2rem">
                            <v-flex xs12>
                            <v-layout>
                            <v-flex xs3><v-icon small style="margin-right:5px">date_range</v-icon>Create timestamp:</v-flex>
                            <v-flex xs9>{{apiKey.createTime}}</v-flex>
                            </v-layout>
                            </v-flex>
                            <v-flex xs12>
                            <v-layout>
                            <v-flex xs3><v-icon small style="margin-right:5px">date_range</v-icon>Last update:</v-flex>
                            <v-flex xs9>{{apiKey.lastUpdateTime}}</v-flex>
                            </v-layout>
                            </v-flex>
                            <v-flex>
                            <v-layout>
                                <v-flex xs3><v-icon small style="margin-right:5px">check_circle_outline</v-icon>Status:</v-flex>
                                <v-flex xs9>
                                <led
                                    :classObj="(!apiKey.enabled)?{
                                            'led-red':true
                                        }:{
                                            'led-green':true
                                        }"
                                    :label="apiKey.enabled?'Enabled':'Disabled'"
                                ></led>
                                </v-flex>
                            </v-layout>
                            </v-flex>

                            <v-flex xs12>
                            <v-layout>
                                <v-flex xs3>
                                <v-icon small style="margin-right:5px">view_headline</v-icon>Value:
                                </v-flex>
                                <v-flex xs9 >
                                <v-text-field
                                style="margin:0;padding:0;width:90%"
                                :disabled="true"
                                :value="apiKey.value"
                                :ref="apiKey.value"
                                ></v-text-field>
                                </v-flex>
                            </v-layout>
                            </v-flex>
                        </v-layout>
                        </v-card-text>
                        <v-card-actions style="padding-top:0;">
                        <v-spacer></v-spacer>
                        <v-btn 
                            outline small color="red" 
                            v-on:click=";$store.dispatch('apiKeys/deleteApiKey',apiKey);apiKey = null">
                            <v-icon small>close</v-icon> Delete
                        </v-btn>
                        <v-btn 
                            outline small color="#39a9dc"
                            v-on:click="copyToClipboard(apiKey.value)"
                            
                        >
                            <v-icon small>filter_none</v-icon> Copy
                        </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-card-text>


        <v-card-actions>
            <v-spacer></v-spacer>
            <v-alert
                :value="refreshApiKeysHint"
                type="success"
                class="hint"
                transition="scale-transition"
            >
                Please, refresh api-key list
            </v-alert>
            <v-btn 
                dark icon class="blue"
                v-on:click="$store.dispatch('apiKeys/fetchApiKeys');refreshApiKeysHint=false"
            >
                <v-icon>sync</v-icon>
            </v-btn>
            <v-btn dark icon class="blue" v-on:click="openApiKeyRegistrationProcess=!openApiKeyRegistrationProcess">
                <v-icon>add</v-icon>
            </v-btn>
            <register-apikey
                v-if="openApiKeyRegistrationProcess==true"
                v-on:abort="openApiKeyRegistrationProcess=false;"
                v-on:completed="openApiKeyRegistrationProcess=false;refreshApiKeysHint=true"
            ></register-apikey>
        </v-card-actions>

    </v-card>   


</template>
<script>
import { mapState } from 'vuex';

export default {

    name: "ApiKeysSettings",

    props:{
        theme:String
    },

    components:{
        itemlist: require('../../ItemList').default
    },

    data(){
        return {
            refreshApiKeysHint:false,
            openApiKeyRegistrationProcess:false,
            apiKey: null,
        }
    },

    computed:{
        ...mapState(
            {
                lastOperationMessage:'lastOperationMessage',
                lastOperationSuccess:'lastOperationSuccess',
                operationInProcess:'operationInProcess',
                operationInProcessMessage: 'operationInProcessMessage',
                deviceProfiles: state => state.deviceProfiles.deviceProfiles,
                dataConverters: state => state.deviceProfiles.dataConverters,
                apiKeys: state => state.apiKeys.apiKeys,
                firmwares : state => state.devices.firmwares,
                appMetadata: state => state.metadata.models.views
            }
        ),
    },

    methods:{
        copyToClipboard: function(ref){
            navigator.clipboard.writeText(ref)
        }
    }
}
</script>
